var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { BFFAnswerAdaptiveCard } from '../components/bffAnswerAdaptiveCard';
export const bffAnswerAttachmentMiddleware = () => (next) => (_a) => {
    var { activity, attachment } = _a, others = __rest(_a, ["activity", "attachment"]);
    switch (attachment.contentType) {
        case 'application/vnd.microsoft.card.adaptive':
            return React.createElement(BFFAnswerAdaptiveCard, { activity: activity, attachment: attachment });
        default:
            return next(Object.assign({ activity, attachment }, others));
    }
};
//# sourceMappingURL=bffAnswerAttachmentMiddleware.js.map